


import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";
import { CancelSharp, Close as CloseIcon, Description } from "@mui/icons-material";
import { Formik, Form, useFormikContext } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import './EditProfileModal.css'; // Import external CSS
// import "../../../../Components/ModalCss/BannerinputGetModal.css";

import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import { toast, ToastContainer } from "react-toastify";
import actions from "../../../ReduxStore/actions";
import { useDispatch, useSelector } from "react-redux";
import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
import { updateAwardAction } from "../../../ReduxStore/Slices/EditProfile/updateAward";

const validationSchema = Yup.object().shape({
    // description: Yup.string().required("Description is required"),
    feild: Yup.string().required("Field is required"), // Assuming "feild" is a typo for "field"
    // file1: Yup.mixed().required("File is required"),
    organization: Yup.string().required("Organization is required"),
    award_date: Yup.date().required("Award date is required"),
    award_name: Yup.string().required("Award name is required"),
});

const AwardCreateModal = ({
    // handleImageClick,
    open,
    onClose,
    setSubmittedValues,
    submittedValues,
    setAwardEditData,
    awardEditData
}) => {
    const [uploadedFile, setUploadedFile] = useState(null);
    console.log(uploadedFile, "uploadedFile")
    const dispatch = useDispatch()
    const { getAwardById } = useSelector(state => state?.getAwardById);
    const { createAward } = useSelector(state => state?.createAward);
    const { updateAward } = useSelector(state => state?.updateAward);

    console.log(getAwardById, "getAwardById")
    // console.log(awardEditId, "awardEditId")





    useEffect(() => {
        const certificateFile = awardEditData?.certificate_file;
        console.log("uploadefile")
        if (certificateFile) {
            setUploadedFile({
                fileUrl: certificateFile,
                type: "img", // ensure this is the expected type
                progress: 100,
            });
        }
    }, [awardEditData]);

    const sessionUserId = sessionStorage.getItem("userId")
    const handleCrate = async (values, { resetForm }) => {

        if (!awardEditData?.award_id) {
            const data1 = {
                data: {
                    user_id: sessionUserId,
                    award_name: values?.award_name,
                    title: values?.feild,
                    issued_by: values?.organization,
                    award_date: values?.award_date,
                    description: values?.description,
                    certificate_file: values?.file1
                },
                method: "post",
                apiName: `createAward`,
            };
            const response = await dispatch(actions.CREATEAWARD(data1));
            console.log(response, "responsedataaaaaaa")
            if (response?.payload?.message === "Award created successfully") {
                toast?.success('Award created successfully')
                setTimeout(() => {
                    onClose()
                    resetForm()
                    setUploadedFile(null)
                }, 1500)
            } else {
                toast.error(response?.payload?.message)
            }
        } else {
            const data1 = {
                data: {
                    award_name: values?.award_name,
                    title: values?.feild,
                    issued_by: values?.organization,
                    award_date: values?.award_date,
                    description: values?.description,
                    certificate_file: values?.file1
                },
                method: "put",
                apiName: `updateAward/${awardEditData?.award_id}`,
            };
            const response = await dispatch(actions.UPDATEAWARD(data1));
            console.log(response, "responsedataaaaaaa")
            if (response?.payload?.message === "Award updated successfully") {
                toast?.success('Award updated successfully')
                setTimeout(() => {
                    onClose()
                    resetForm()
                    setUploadedFile(null)
                    setAwardEditData(null)
                }, 2000)
            } else {
                toast.error(response?.payload?.message)
            }

        }


    }


    // useEffect(() => {

    //     if (awardEditId !== null) {

    //         const fetchData = async () => {
    //             const data1 = {
    //                 data: {},
    //                 method: "get",
    //                 apiName: `getAwardById/${awardEditId}`,
    //             };
    //             const response = await dispatch(actions.GETAWARDBYID(data1));
    //         }
    //         fetchData()
    //     }

    // }, [awardEditId]);



    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose()
                setAwardEditData(null)
                setUploadedFile(null)

            }
            }
            fullWidth
            maxWidth="md"
            className="custom-dialog"
            sx={{
                maxWidth: "700px",
                margin: "auto",
                "& .MuiPaper-root": {
                    borderRadius: "14px", // Target the Paper component
                },
            }}
        >
            <Box sx={{ position: "relative" }}>
                <Box className="dialog-heading">
                    <IconButton
                        aria-label="Close"
                        onClick={() => {
                            onClose()
                            setAwardEditData(null)
                            setUploadedFile(null)

                        }}
                        sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            color: 'white',
                        }}
                    >
                        <MdCancel />
                    </IconButton>
                    <DialogTitle className="custom-dialog-title">
                        <Box>
                            <Typography variant="subtitle1" sx={{ color: "white" }}>
                                {awardEditData ? "Edit Award" : "Add Award"}
                            </Typography>
                        </Box>
                    </DialogTitle>
                </Box>
                <DialogContent sx={{ overflowY: "scroll", height: "400px" }}>
                    {/* <Box sx={{ position: "absolute", right: "10px", top: 5 }}>
                        <CancelSharp
                            style={{ display: { sx: "none", md: "block" } }}
                            // onClick={() => {
                            //     navigate("/")
                            // }}
                        />
                    </Box> */}
                    <Grid
                        item
                        size={{ md: 5, xs: 12 }}


                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            // p: 2,
                            background: '#FFFFFF',
                            width: '100%',

                        }}
                    >

                        <Box sx={{
                            // display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            // boxShadow: { xs: 0, sm: 4, md: 4 },
                            padding: { xs: 0, sm: 1, md: 2 },
                            width: "100%",
                            // boxShadow: 4,
                            // m: 4


                            // border: "1px solid red"
                        }}>


                            <Formik
                                enableReinitialize
                                initialValues={{
                                    // description: "",
                                    // feild: "",
                                    // file1: "",
                                    // organization: "",
                                    // award_date: "",
                                    // award_name: "",

                                    description: awardEditData?.description || "",
                                    feild: awardEditData?.title || "",
                                    file1: awardEditData?.certificate_file || "",
                                    organization: awardEditData?.issued_by || "",
                                    award_date: awardEditData?.award_date || "",
                                    award_name: awardEditData?.award_name || "",


                                }}
                                validationSchema={validationSchema}
                                onSubmit={handleCrate}
                            >
                                {({ handleSubmit, resetForm, setFieldValue }) => (

                                    <Form onSubmit={handleSubmit}>
                                        < Grid container columnSpacing={4} rowSpacing={2}>
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="award_name"
                                                    label="Award Name"
                                                    inputType="text"
                                                    custPlaceholder="Enter your award name"
                                                    important={true}
                                                />
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomDateInput
                                                    name="award_date"
                                                    label="Award Date"
                                                    custPlaceholder="Enter your award date"
                                                    important={true}


                                                />

                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="organization"
                                                    label="Organization"
                                                    inputType="text"
                                                    custPlaceholder="Enter your organization"
                                                    important={true}

                                                />
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6, sm: 6 }}>
                                                <CustomInputLogin
                                                    name="feild"
                                                    label="Field"
                                                    inputType="text"
                                                    custPlaceholder="Enter your field"
                                                    important={true}

                                                />
                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12, sm: 6 }}>
                                                <FileUploadComponent
                                                    name="file1"
                                                    uploadedFile={uploadedFile}
                                                    setUploadedFile={setUploadedFile}
                                                    onFileUpload={(file) => setFieldValue("file1", file)}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 12, sm: 12 }}>
                                                <CustomInputLogin
                                                    name="description"
                                                    label="Description"
                                                    inputType="textarea"
                                                    custPlaceholder="Enter your description"
                                                />
                                            </Grid>


                                            <Grid size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "end" }}>
                                                <Button
                                                    variant="contained"
                                                    type="submit"
                                                    // onClick={handleGoRegisterComplete}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "white",
                                                        fontSize: "16px",
                                                        mr: 2,
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        boxShadow: "none",

                                                        // borderRadius: "23px",
                                                        background: "var(--main-color) 0% 0% no-repeat padding-box",
                                                        "&:hover": {
                                                            backgroundColor: "var(--main-color)",
                                                        },
                                                    }}
                                                >
                                                    {awardEditData?.award_id ? "Update" : "Submit"}
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    // type="submit"
                                                    onClick={() => {
                                                        resetForm()

                                                    }}
                                                    // sx={{ textTransform: "none", background: "#C38F51", color: "white", borderRadius: "23px" }}
                                                    sx={{
                                                        // backgroundColor: "#C38F51",
                                                        textTransform: "none",
                                                        color: "black",
                                                        fontSize: "16px",
                                                        // padding: "0px 40px",
                                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                                        minHeight: "40px",
                                                        // boxShadow: 2,
                                                        // border:"1px solid gray",

                                                        // borderRadius: "23px",
                                                        background: "white 0% 0% no-repeat padding-box",
                                                        // "&:hover": {
                                                        //     backgroundColor: "#3B4056",
                                                        // },
                                                    }}
                                                >
                                                    Cancel
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        </Box>
                    </Grid>
                </DialogContent>
                <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                />


            </Box>
        </Dialog >
    );
};

export default AwardCreateModal;
